<template>
    <div class="form-container card shadow-sm p-3">
      <!-- Cabeçalho -->
      <div class="header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          {{ venda.id ? `Editar Venda nº ${venda.id}` : 'Nova Venda' }}
        </h4>
        <button class="btn btn-secondary" @click="cancelar">Voltar</button>
      </div>
  
      <div class="spacer"></div>
      <p v-if="erroProdutos" role="alert" class="alert alert-danger">{{ erroProdutos }}</p>
      <p v-else-if="produtosCarregados && !produtos.length" role="status" class="alert alert-info">Nenhum produto ativo disponível.</p>
      <p v-if="erroContas" role="alert" class="alert alert-danger">{{ erroContas }}</p>
      <p v-else-if="contasCarregadas && !contasFinanceiras.length" role="status" class="alert alert-info">Nenhuma conta disponível nesta escola.</p>
  
      <!-- Seção 1: Dados do Cliente -->
      <div class="form-section">
        <h5 class="section-title">Dados do Cliente</h5>
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label>Cliente <span class="required">*</span></label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control pessoa-input disabled-input"
                  :value="venda.cliente_nome || ''"
                  disabled
                  required
                />
                <button
                  class="btn btn-primary pessoa-icon-btn"
                  type="button"
                  @click="abrirModalPessoa"
                >
                  <i class="bi bi-person"></i>
                </button>
              </div>
            </div>
            <!-- mensagem de matrícula -->
            <div v-if="matriculasList.length" class="text-muted mt-1">
                <em>{{ textoMatriculas }}</em>
            </div>
            <div v-else class="text-muted mt-1">
                <em>Não existe matrícula vinculada ao cliente</em>
            </div>

          </div>
        </div>
      </div>

 
      <!-- Seção 2: Itens de Venda -->
      <div class="form-section">
        <h5 class="section-title">Itens de Venda</h5>
        <table class="table table-borderless">
          <thead>
            <tr>
              <th style="width: 50%;">Produto <span class="required">*</span></th>
              <th style="width: 10%;">Qtd. <span class="required">*</span></th>
              <th>Preço Unit.</th>
              <th>Subtotal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in venda.itens" :key="idx">
              <!-- Seleção de Produto -->
              <td>
                <select
                  v-model.number="item.produto_id"
                  @change="selecionarProduto(idx)"
                  class="form-control"
                  required
                >
                  <option value="">Selecione</option>
                  <option
                    v-for="p in produtos"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.texto }}
                  </option>
                </select>
              </td>

              <!-- Quantidade com aviso de estoque -->
              <td>
                <input
                  type="number"
                  v-model.number="item.quantidade"
                  min="1"
                  class="form-control"
                  @input="checkEstoque(idx)"
                  required
                />
                <!-- <small class="text-muted">
                  (estoque: {{ produtos.find(p => p.id === item.produto_id)?.estoque ?? 0 }})
                </small> -->
              </td>

              <!-- Preço Unitário -->
              <td>
                <input
                  type="text"
                  v-model="item.preco_unit_input"
                  class="form-control"
                  :readonly="!canEditPrecoUnitario"
                  :disabled="!canEditPrecoUnitario"
                  @blur="aplicarPrecoUnitario(idx)"
                  placeholder="0,00"
                />
              </td>

              <!-- Subtotal -->
              <td>
                <input
                  type="text"
                  :value="formatDecimal(item.subtotal)"
                  class="form-control"
                  readonly
                />
              </td>

              <!-- Botão Remover -->
              <td class="text-center">
                <button @click="removerItem(idx)" class="btn btn-danger btn-sm">
                  🗑️
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Controles de Itens e Total -->
        <div class="d-flex justify-content-between align-items-center mt-2">
          <button @click="adicionarItem" class="btn btn-primary">
            <i class="bi bi-plus"></i>
          </button>
          <div><strong>Total: R$ {{ formatDecimal(totalVendaEfetivo) }}</strong></div>
        </div>
      </div>
  
      <!-- Seção 3: Detalhes do Pagamento -->
      <div class="form-section">
        <h5 class="section-title">Detalhes do Pagamento</h5>
        <div class="row align-items-start">
          <div class="col-md-2">
            <div class="form-group">
              <label for="data_venda">Data da Venda <span class="required">*</span></label>
              <input
                id="data_venda"
                type="date"
                v-model="venda.data_venda"
                class="form-control"
              />
            </div>
          </div>

          <!-- Nº de Parcelas -->
          <div class="col-md-1">
            <div class="form-group">
              <label for="parcelas">Parcelas</label>
              <input
                id="parcelas"
                type="number"
                v-model.number="parcelasCount"
                min="1"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <!-- Tabela de Parcelas -->
        <div class="table-responsive mb-3">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th>Parcela</th>
                <th>Forma de Pagamento<span class="required">*</span></th>
                <th>Autorização</th>
                <th>Vencimento<span class="required">*</span></th>
                <th>Valor</th>
                <th>Pagamento<span class="required">*</span></th>
                <th>Recebimento</th>
                <th>Conta Financeira<span class="required">*</span></th>
                <th v-if="showChequeCols">Banco nº<span class="required">*</span></th>
                <th v-if="showChequeCols">Agência<span class="required">*</span></th>
                <th v-if="showChequeCols">Cheque nº<span class="required">*</span></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in parcelasArray" :key="i">
                <td>{{ i + 1 }}</td>

                <td>
                  <select
                    v-model.number="p.forma_pagamento_id"
                    class="form-control"
                    required
                    @change="onParcelaFormaChange(p)"
                  >
                    <option value="">Selecione</option>
                    <option v-for="fp in formasPagamento" :key="fp.id" :value="fp.id">
                      {{ fp.nome }}
                    </option>
                  </select>
                </td>

                <td>
                  <input
                    v-if="isFormaComAutorizacao(p.forma_pagamento_id)"
                    v-model="p.numero_autorizacao"
                    type="text"
                    class="form-control"
                    placeholder="Autorização"
                    @input="onNumeroAutorizacaoParcelaInput(p)"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                  />
                </td>

                <td>
                  <input
                    type="date"
                    v-model="p.data_vencimento"
                    class="form-control"
                    required
                  />
                </td>

                <td>
                  <input
                    type="text"
                    :value="formatDecimal(p.valor)"
                    class="form-control"
                    readonly
                  />
                </td>

                <td>
                  <input
                    type="date"
                    v-model="p.data_pagamento"
                    class="form-control"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                  />
                </td>

                <td>
                  <input
                    type="date"
                    v-model="p.data_recebimento"
                    class="form-control"
                    disabled
                  />
                </td>

                <td>
                  <select
                    v-model.number="p.conta_financeira_id"
                    class="form-control"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                    :required="!isAInformar(p.forma_pagamento_id) && !!(p.data_pagamento && p.data_pagamento.trim())"
                    @change="onContaFinanceiraParcelaChange(p)"
                  >
                    <option v-if="isAInformar(p.forma_pagamento_id)" :value="null">A informar</option>

                    <template v-else>
                      <option :value="null" disabled>Selecione</option>
                      <option v-for="c in contasFinanceiras" :key="c.id" :value="c.id">
                        {{ c.texto }}
                      </option>
                    </template>
                  </select>
                </td>

                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.banco_numero"
                    type="text"
                    class="form-control"
                    placeholder="Banco nº"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>

                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.agencia"
                    type="text"
                    class="form-control"
                    placeholder="Agência"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>

                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.cheque_numero"
                    type="text"
                    class="form-control"
                    placeholder="Cheque nº"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <!-- Botões de Ação -->
      <div class="form-actions d-flex justify-content-end">
        <button
          class="btn btn-primary me-2"
          :disabled="!formValid || isSubmitting"
          @click="salvarVenda"
        >
          <i class="bi bi-save me-1"></i>
          {{ isSubmitting ? 'Salvando…' : 'Finalizar' }}
        </button>
        <button
          class="btn btn-secondary"
          :disabled="isSubmitting"
          @click="cancelar"
        >
          <i class="bi bi-x-circle me-1"></i>
          Cancelar
        </button>
      </div>
  
      <!-- Modal para seleção de Cliente -->
      <CarregarPessoa
        :mostrar="modalPessoaAberto"
        @fechar="fecharModalPessoa"
        @selecionar="selecionarPessoa"
      ></CarregarPessoa>
    </div>
  </template>
  
<script setup>
import { paymentCollectionOperations } from "@/utils/operationalPaymentPayload";
let originalPayments = [];
  import { ref, reactive, computed, watch, watchEffect, onMounted, getCurrentInstance } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import axios from '@/services/axios';
  import { loadOperationalAccounts } from '@/services/operationalAccounts';
  import { loadLojaProducts, lojaSelectionError } from '@/services/lojaSelection';
  import CarregarPessoa from '@/components/modals/CarregarPessoa.vue';
  import globalUtils from '@/utils/globalUtils.js';
  
  let loadedParcels = false;

  // Instâncias do router e estado global
  const router = useRouter();
  const route = useRoute();
  const { appContext } = getCurrentInstance();
  const userName = appContext.config.globalProperties.$globalState.userName;
  
  // Helpers
  function toDateInputValue(iso) {
    return iso ? iso.split('T')[0] : '';
  }
  function formatDecimal(val) {
    const num = Number(val);
    if (isNaN(num)) return '';
    return num.toFixed(2).replace('.', ',');
  }
  
  // Data de hoje em formato YYYY-MM-DD
  const hoje = toDateInputValue(new Date().toISOString());
  
  // Estado principal da venda
  const venda = reactive({
    id: null,
    cliente_pessoa_fisica: true,
    cliente_id: null,
    cliente_nome: '',
    data_venda: hoje,
    data_pagamento: '',
    forma_pagamento_id: null,
    pendente: false,
    parcelas: 1,
    itens: []  // { produto_id, produto_texto, quantidade, preco_unit, subtotal }
  });
  
  // Controles de parcelamento
  const parcelasCount   = ref(venda.parcelas);
  const parcelasArray   = ref([]);
  
  // Dropdowns e modais
  const produtos            = ref([]);
  const formasPagamento     = ref([]);
  const isSubmitting        = ref(false);
  const contasFinanceiras   = ref([]);
  const modalPessoaAberto   = ref(false);
  const matriculasList      = ref([]);
  
  const norm = s => (s ?? '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .trim().toLowerCase();

  const getFormaById = (id) => formasPagamento.value.find(f => Number(f.id) === Number(id));

  const isCartaoCreditoAVista = (formaId) => {
    const n = norm(getFormaById(formaId)?.nome);
    return (
      n === 'cartao de credito' ||
      n === 'cartao de credito a vista' ||
      (n.includes('cartao') && n.includes('credito') && n.includes('vista'))
    );
  };

  const isCartaoCreditoParcelado = (formaId) => {
    const n = norm(getFormaById(formaId)?.nome);
    return n.includes('cartao') && n.includes('credito') && n.includes('parcelado');
  };

  const isCartaoDebito = (formaId) => {
    const n = norm(getFormaById(formaId)?.nome);
    return n.includes('cartao') && n.includes('debito');
  };

  const isCheque = (formaId) => {
    const n = norm(getFormaById(formaId)?.nome);
    return n === 'cheque';
  };

  const isFormaComAutorizacao = (formaId) => {
    return (
      isCartaoCreditoAVista(formaId) ||
      isCartaoCreditoParcelado(formaId) ||
      isCartaoDebito(formaId)
    );
  };

  const getParcelasOrdenadas = () => {
  return parcelasArray.value
    .slice()
    .sort((a, b) => String(a?.data_vencimento || '').localeCompare(String(b?.data_vencimento || '')));
};

const getBlocoParceladoDaParcela = (parcela) => {
  const lista = getParcelasOrdenadas();
  const idx = lista.findIndex(p =>
    p === parcela || (p?.id && parcela?.id && Number(p.id) === Number(parcela.id))
  );

  if (idx === -1) return [];
  if (!isCartaoCreditoParcelado(lista[idx]?.forma_pagamento_id)) return [lista[idx]];

  let ini = idx;
  let fim = idx;

  while (ini > 0 && isCartaoCreditoParcelado(lista[ini - 1]?.forma_pagamento_id)) ini--;
  while (fim < lista.length - 1 && isCartaoCreditoParcelado(lista[fim + 1]?.forma_pagamento_id)) fim++;

  return lista.slice(ini, fim + 1);
};

const getNumeroParcelaNoBlocoParcelado = (parcela) => {
  const bloco = getBlocoParceladoDaParcela(parcela);
  const idx = bloco.findIndex(p =>
    p === parcela || (p?.id && parcela?.id && Number(p.id) === Number(parcela.id))
  );
  return idx >= 0 ? idx + 1 : 1;
};

const isInicioBlocoParcelado = (parcela) => {
  if (!isCartaoCreditoParcelado(parcela?.forma_pagamento_id)) return false;

  const lista = getParcelasOrdenadas();
  const idx = lista.findIndex(p =>
    p === parcela || (p?.id && parcela?.id && Number(p.id) === Number(parcela.id))
  );

  if (idx === -1) return false;
  if (idx === 0) return true;

  return !isCartaoCreditoParcelado(lista[idx - 1]?.forma_pagamento_id);
};

const propagarBlocoParceladoParaLinhasVazias = (parcela) => {
  if (!isInicioBlocoParcelado(parcela)) return;

  const lista = getParcelasOrdenadas();
  const idx = lista.findIndex(p =>
    p === parcela || (p?.id && parcela?.id && Number(p.id) === Number(parcela.id))
  );

  if (idx === -1) return;

  const autorizacao = (parcela.numero_autorizacao || '').trim();
  const conta = parcela.conta_financeira_id ?? null;

  for (let i = idx + 1; i < lista.length; i++) {
    const atual = lista[i];
    const formaAtual = atual?.forma_pagamento_id;

    // para ao encontrar uma próxima linha já definida
    if (formaAtual !== null && formaAtual !== '' && formaAtual !== undefined) {
      break;
    }

    atual.forma_pagamento_id = parcela.forma_pagamento_id;

    if (!(atual.numero_autorizacao || '').trim() && autorizacao) {
      atual.numero_autorizacao = autorizacao;
    }

    if (
      (atual.conta_financeira_id === null ||
        atual.conta_financeira_id === '' ||
        atual.conta_financeira_id === undefined) &&
      conta
    ) {
      atual.conta_financeira_id = conta;
    }

    if (!atual.data_pagamento) {
      atual.data_pagamento = atual.data_vencimento || '';
    }
  }
};

const getDataBaseBlocoParcelado = (parcela) => {
  const bloco = getBlocoParceladoDaParcela(parcela);
  const primeira = bloco?.[0];

  if (!primeira) return null;

  return (
    primeira.data_pagamento ||
    primeira.data_vencimento ||
    parcela.data_pagamento ||
    parcela.data_vencimento ||
    null
  );
};

const replicarAutorizacaoNoBlocoParcelado = (parcela) => {
  if (!isCartaoCreditoParcelado(parcela?.forma_pagamento_id)) return;
  const bloco = getBlocoParceladoDaParcela(parcela);
  const valor = (parcela.numero_autorizacao || '').trim();
  bloco.forEach(p => {
    p.numero_autorizacao = valor || null;
  });
};

const replicarContaNoBlocoParcelado = (parcela) => {
  if (!isCartaoCreditoParcelado(parcela?.forma_pagamento_id)) return;
  const bloco = getBlocoParceladoDaParcela(parcela);
  const conta = parcela.conta_financeira_id ?? null;
  bloco.forEach(p => {
    p.conta_financeira_id = conta;
  });
};

const onNumeroAutorizacaoParcelaInput = (parcela) => {
  if (isCartaoCreditoParcelado(parcela?.forma_pagamento_id)) {
    replicarAutorizacaoNoBlocoParcelado(parcela);
  }
};

const onContaFinanceiraParcelaChange = (parcela) => {
  if (isCartaoCreditoParcelado(parcela?.forma_pagamento_id)) {
    replicarContaNoBlocoParcelado(parcela);
  }
};

  const contaPadraoGlobalId = computed(() => {
  const c = (contasFinanceiras.value || []).find(x => x.conta_padrao === true || x.conta_padrao === 1);
  return c?.id ? Number(c.id) : null;
});


  // ✅ por forma -> fallback global (exceto espécie/a informar)
  const aplicarContaPadraoSeVazio = (formaId, parcela) => {
    const forma = getFormaById(formaId);
    if (!forma || !parcela) return;

    const nome = norm(forma.nome);
    if (nome === 'especie' || nome === 'a informar' || nome === 'informar') return;

    if (parcela.conta_financeira_id != null && parcela.conta_financeira_id !== '') return;

    const porForma = forma.conta_financeira_padrao_id ? Number(forma.conta_financeira_padrao_id) : null;
    if (porForma) {
      parcela.conta_financeira_id = porForma;
      return;
    }
    if (contaPadraoGlobalId.value) parcela.conta_financeira_id = contaPadraoGlobalId.value;
  };

  const idBrinde = computed(() =>
    formasPagamento.value.find(fp => norm(fp.nome) === 'brinde')?.id ?? null
  );

  const hasBrinde = computed(() =>
    parcelasArray.value.some(p => p.forma_pagamento_id === idBrinde.value)
  );

  const idCheque = computed(() => {
    return formasPagamento.value.find(fp =>
      fp.nome.toLowerCase() === 'cheque'
    )?.id || null;
  });

  const showChequeCols = computed(() =>
    parcelasArray.value.some(p => p.forma_pagamento_id === idCheque.value)
  );

  // Computed: "total da venda"
  const totalVenda = computed(() =>
    venda.itens.reduce((sum, i) => sum + (i.subtotal || 0), 0).toFixed(2)
  );

  // ID da forma “A informar”
  const idAInformar = computed(() =>
    formasPagamento.value.find(f => f.nome.toLowerCase() === 'a informar')?.id || null
  );
  // ID da forma “Espécie”

  function isAInformar(id) {
    return id === idAInformar.value;
  }
 
  // Computed: texto de matrículas
  const textoMatriculas = computed(() => {
    const somenteAluno = matriculasList.value.filter(m => m.aluno_id === venda.cliente_id);
    if (somenteAluno.length) {
      const ids = somenteAluno.map(m => m.matricula_id).join(', ');
      return `Aluno – Matrícula: ${ids}`;
    }
    const comoResp = matriculasList.value.filter(m => m.responsavel_id === venda.cliente_id);
    if (comoResp.length) {
      const nomes = comoResp.map(m => m.aluno_nome).join(' e ');
      const ids   = comoResp.map(m => m.matricula_id).join(', ');
      return comoResp.length > 1
        ? `Responsável dos alunos ${nomes} – Matrículas: ${ids}`
        : `Responsável do aluno ${nomes} – Matrícula: ${ids}`;
    }
    return '';
  });
  
  const { proxy } = getCurrentInstance();

  const canEditPrecoUnitario = computed(() => {
    const globalState = appContext?.config?.globalProperties?.$globalState ?? {};
    const perfil = String(globalState.userProfile || '').trim().toLowerCase();
    const permissoes = Array.isArray(globalState.userPermissions)
      ? globalState.userPermissions
      : [];

    return perfil === 'administrador' || permissoes.includes('super_administrador');
  });

  function checkEstoque(idx) {
    const item = venda.itens[idx];
    const prod = produtos.value.find(p => p.id === item.produto_id);
    if (!prod) return;
    if (item.quantidade > prod.estoque) {
      // item.quantidade = prod.estoque;
      proxy?.$toast.warning(`Máximo disponível: ${prod.estoque}`);
    }
  }

// teste deploy

  function parseMoedaBR(valor) {
    if (valor === null || valor === undefined) return 0;

    const texto = String(valor)
      .trim()
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.-]/g, '');

    const numero = Number(texto);
    return Number.isFinite(numero) ? numero : 0;
  }

  function aplicarPrecoUnitario(idx) {
    const item = venda.itens[idx];
    if (!item) return;

    const numero = parseMoedaBR(item.preco_unit_input);
    item.preco_unit = +numero.toFixed(2);
    item.preco_unit_input = formatDecimal(item.preco_unit);
    item.subtotal = +(item.quantidade * item.preco_unit).toFixed(2);
  }

  // Gera o array de parcelas (vencimento mês a mês)
  function geraParcelas(count) {
    const baseTotal = Number(totalVenda.value) || 0;
    const base      = Number((baseTotal / count).toFixed(2));
    const last      = Number((baseTotal - base * (count - 1)).toFixed(2));
    const hojeDate  = new Date();

    const arr = [];
    for (let i = 0; i < count; i++) {
      const dt = new Date(hojeDate);
      dt.setMonth(hojeDate.getMonth() + i);

      const venc = globalUtils.nextBusinessDay(dt);
      const yyyy = venc.getFullYear();
      const mm   = String(venc.getMonth() + 1).padStart(2, '0');
      const dd   = String(venc.getDate()).padStart(2, '0');

      arr.push({
        id: null,
        venda_id: venda.id,
        forma_pagamento_id: null,
        data_vencimento: `${yyyy}-${mm}-${dd}`,
        valor: i < count - 1 ? base : last,
        data_pagamento: `${yyyy}-${mm}-${dd}`,
        data_recebimento: '',
        banco_numero: '',
        agencia: '',
        cheque_numero: '',
        conta_financeira_id: null,
        numero_autorizacao: null,
      });
    }

    parcelasArray.value = arr;
  }
  
  const recalcularRecebimentoParcela = (p) => {
    const fp = p?.forma_pagamento_id;

    if (!fp || isAInformar(fp)) {
      p.data_recebimento = '';
      return;
    }

    if (isCartaoCreditoParcelado(fp)) {
      const numeroParcela = getNumeroParcelaNoBlocoParcelado(p);
      const dataBaseOperacao = getDataBaseBlocoParcelado(p);

      if (!dataBaseOperacao) {
        p.data_recebimento = '';
        return;
      }

      p.data_recebimento = globalUtils.calcularDataRecebimento(
        dataBaseOperacao,
        fp,
        formasPagamento.value,
        numeroParcela
      ) || '';
      return;
    }

    if (!p.data_pagamento) {
      p.data_recebimento = '';
      return;
    }

    p.data_recebimento = globalUtils.calcularDataRecebimento(
      p.data_pagamento,
      fp,
      formasPagamento.value,
      1
    ) || '';
  };

  const recalcularRecebimentoBlocoParcelado = (parcela) => {
    const bloco = getBlocoParceladoDaParcela(parcela);
    if (!bloco.length) return;

    const primeira = bloco[0];

    if (!primeira.data_pagamento) {
      primeira.data_pagamento = primeira.data_vencimento || '';
    }

    const dataBaseOperacao = getDataBaseBlocoParcelado(primeira);

    bloco.forEach((p, idx) => {
      if (!p.data_pagamento) {
        p.data_pagamento = p.data_vencimento || '';
      }

      if (!dataBaseOperacao) {
        p.data_recebimento = '';
        return;
      }

      p.data_recebimento = globalUtils.calcularDataRecebimento(
        dataBaseOperacao,
        p.forma_pagamento_id,
        formasPagamento.value,
        idx + 1
      ) || '';
    });
  };

  const erroProdutos = ref('');
  const erroContas = ref('');
  const produtosCarregados = ref(false);
  const contasCarregadas = ref(false);

  // Carrega contas financeiras
  async function carregarContasFinanceiras() {
    try {
      contasFinanceiras.value = await loadOperationalAccounts(route.params.id ? 'venda_alteracao' : 'venda_inclusao');
      contasCarregadas.value = true;
    } catch (error) {
      erroContas.value = lojaSelectionError(error, 'contas');
    }
  }
  
  // Busca matrículas por cliente
  async function buscarMatriculas(clienteId) {
    try {
      const resp = await axios.get('/operacional/matriculas/por-cliente', { params: { cliente_id: clienteId } });
      matriculasList.value = resp.data ?? [];
    } catch {
      matriculasList.value = [];
    }
  }
  
  // Watch: ao mudar número de parcelas, regenera o array
  watch(parcelasCount, newVal => {
    venda.parcelas = newVal;
    geraParcelas(newVal);
  });
  
  watchEffect(() => {
    venda.itens.forEach(i => {
      i.subtotal = +(i.quantidade * i.preco_unit).toFixed(2);
    });
  });
  
watchEffect(() => {
  const total = Number(totalVenda.value) || 0;
  const count = parcelasCount.value || 1;

  // valor padrão e último para ajustar arredondamentos
  const base  = Number((total / count).toFixed(2));
  const last  = Number((total - base * (count - 1)).toFixed(2));

  parcelasArray.value.forEach((p, idx) => {
    // 👇 Se for Brinde, mantém zero; caso contrário, recalcula normalmente
    if (p.forma_pagamento_id === idBrinde.value) {
      p.valor = 0;
    } else {
      p.valor = idx < count - 1 ? base : last;
    }
  });
});

  watch(
    () => venda.pendente,
    (novo, antigo) => {
      // se estava pendente e agora não está
      if (antigo === true && novo === false) {
        // escolhe 1 parcela
        parcelasCount.value = 1;
        // gera automaticamente a linha de parcela
        geraParcelas(1);
      }
    }
  );


watch(
  () => parcelasArray.value.map(p => [p.data_pagamento, p.forma_pagamento_id]),
  () => {
    if (!loadedParcels) return;

    parcelasArray.value.forEach(p => {
      if (isCartaoCreditoParcelado(p.forma_pagamento_id)) {
        recalcularRecebimentoBlocoParcelado(p);
      } else {
        recalcularRecebimentoParcela(p);
      }
    });
  },
  { deep: true }
);

function onParcelaFormaChange(p) {
  const fp = p.forma_pagamento_id;

  if (!fp) {
    p.data_pagamento = '';
    p.data_recebimento = '';
    p.conta_financeira_id = null;
    p.numero_autorizacao = null;
    return;
  }

  const isBrindeLocal = (idBrinde.value != null && fp === idBrinde.value);

  if (isBrindeLocal) {
    p.valor = 0;
    p.numero_autorizacao = null;
    p.banco_numero = '';
    p.agencia = '';
    p.cheque_numero = '';
    return;
  }

  p.conta_financeira_id = null;
  p.numero_autorizacao = null;

  if (isAInformar(fp)) {
    p.data_pagamento = '';
    p.data_recebimento = '';
    return;
  }

  if (!isCheque(fp)) {
    p.banco_numero = '';
    p.agencia = '';
    p.cheque_numero = '';
  }

  aplicarContaPadraoSeVazio(fp, p);

  if (isCartaoCreditoParcelado(fp)) {
    propagarBlocoParceladoParaLinhasVazias(p);

    const bloco = getBlocoParceladoDaParcela(p);

    const comAutorizacao = bloco.find(x => (x.numero_autorizacao || '').trim());
    if (comAutorizacao) {
      p.numero_autorizacao = (comAutorizacao.numero_autorizacao || '').trim();
    }

    const comConta = bloco.find(x => x.conta_financeira_id != null);
    if (comConta) {
      p.conta_financeira_id = comConta.conta_financeira_id;
    }

    replicarAutorizacaoNoBlocoParcelado(p);
    replicarContaNoBlocoParcelado(p);

    if (!p.data_pagamento) {
      p.data_pagamento = p.data_vencimento || '';
    }

    recalcularRecebimentoBlocoParcelado(p);
    return;
  }

  if (!p.data_pagamento) {
    p.data_pagamento = p.data_vencimento || '';
  }

  recalcularRecebimentoParcela(p);
}

const totalVendaNumber = computed(() =>
  venda.itens.reduce((sum, i) => sum + (i.subtotal || 0), 0)
);

// total a exibir/enviar (se houver brinde, força 0)
const totalVendaEfetivo = computed(() =>
  hasBrinde.value ? 0 : Number(totalVendaNumber.value.toFixed(2))
);



  // onMounted: carga inicial de dados
  onMounted(async () => {
    await carregarContasFinanceiras();
    // Produtos ativos
    // Produtos ativos (pedindo muitos)
    try {
      produtos.value = await loadLojaProducts();
      produtosCarregados.value = true;
    } catch (error) {
      erroProdutos.value = lojaSelectionError(error, 'produtos');
    }
  
    // Formas de pagamento
    try {
      const respF = await axios.get('/cadastros/formas-pagamento');
      const lista = respF.data.data ?? respF.data ?? [];

      const ordemPersonalizada = {
        'pix': 1,
        'especie': 2,
        'cartao de credito a vista': 3,
        'cartao de credito parcelado': 4,
        'cartao de debito': 5,
        'boleto': 6,
        'transferencia bancaria': 7,
        'cheque': 8,
        'a informar': 9,
      };

      formasPagamento.value = lista
        .map(fp => ({
          id: fp.id,
          nome: fp.nome,
          prazo_pagamento: fp.prazo_pagamento,
          conta_financeira_padrao_id: fp.conta_financeira_padrao_id ?? null
        }))
        .sort((a, b) => {
          const oa = ordemPersonalizada[norm(a.nome)] ?? 999;
          const ob = ordemPersonalizada[norm(b.nome)] ?? 999;
          if (oa !== ob) return oa - ob;
          return a.nome.localeCompare(b.nome, 'pt-BR');
        });
    } catch {
      formasPagamento.value = [];
    }
  
    // Se estiver editando
    if (route.params.id) {
      // Carrega venda
      try {
        const { data } = await axios.get(`/loja/vendas/${route.params.id}`);
        Object.assign(venda, {
          id: data.id,
          cliente_pessoa_fisica: data.cliente_pessoa_fisica,
          cliente_id: data.cliente_id,
          cliente_nome: data.cliente_nome,
          data_venda: toDateInputValue(data.data_venda),
          data_pagamento: toDateInputValue(data.data_pagamento),
          forma_pagamento_id: data.forma_pagamento_id,
          pendente: data.pendente,
          parcelas: data.parcelas ?? 1
        });
      } catch (err) {
        console.error('Erro ao carregar venda:', err);
      }
  
      // Carrega matrículas
      await buscarMatriculas(venda.cliente_id);
  
      // Carrega itens
      try {
        const respI = await axios.get('/loja/vendas-itens', { params: { venda_id: venda.id } });
        const lista = respI.data.data ?? respI.data ?? [];
        venda.itens = lista.map(i => ({
          produto_id: i.produto_id,
          produto_texto: produtos.value.find(p => p.id === i.produto_id)?.texto || '',
          quantidade: i.quantidade,
          preco_unit: parseFloat(i.preco_unit),
          preco_unit_input: formatDecimal(parseFloat(i.preco_unit)),
          subtotal: parseFloat(i.subtotal)
        }));
      } catch {
        venda.itens = [];
      }
  
      // Carrega parcelas existentes
      try {
        parcelasCount.value = venda.parcelas;
        const respP = await axios.get(`/loja/vendas-pagamentos/${venda.id}`);
        const lista = respP.data ?? [];
        originalPayments = lista;

        parcelasArray.value = lista.map(p => ({
          id: p.id,
          venda_id: p.venda_id,
          forma_pagamento_id: p.forma_pagamento_id,
          data_vencimento: toDateInputValue(p.data_vencimento),
          valor: Number(p.valor),
          data_pagamento: p.data_pagamento ? toDateInputValue(p.data_pagamento) : '',
          data_recebimento: p.data_recebimento ? toDateInputValue(p.data_recebimento) : '',
          banco_numero: p.banco_numero,
          agencia: p.agencia,
          cheque_numero: p.cheque_numero,
          conta_financeira_id: p.conta_financeira_id,
          numero_autorizacao: p.numero_autorizacao || null,
        }));

      } catch {
        geraParcelas(parcelasCount.value);
      }
    } else {
      // Novo registro
      venda.itens = [];
      adicionarItem();
      geraParcelas(parcelasCount.value);
    }
    loadedParcels = true;
  });
  
  // Modal cliente
  function abrirModalPessoa() {
    modalPessoaAberto.value = true;
  }
  function fecharModalPessoa() {
    modalPessoaAberto.value = false;
  }
  function selecionarPessoa({ id, nome, tipo }) {
    venda.cliente_id = id;
    venda.cliente_nome = nome;
    venda.cliente_pessoa_fisica = tipo === 'fisica';
    buscarMatriculas(id);
    fecharModalPessoa();
  }
  
  // Itens de venda
  function adicionarItem() {
    venda.itens.push({
      produto_id: null,
      produto_texto: '',
      quantidade: 1,
      preco_unit: 0,
      preco_unit_input: '0,00',
      subtotal: 0
    });
  }
  function removerItem(idx) {
    venda.itens.splice(idx, 1);
  }

  function selecionarProduto(idx) {
    const item = venda.itens[idx];
    const encontrado = produtos.value.find(p => p.id === item.produto_id);

    if (encontrado) {
      item.produto_texto = encontrado.texto;
      item.preco_unit = encontrado.preco;
      item.preco_unit_input = formatDecimal(encontrado.preco);
    } else {
      item.produto_texto = '';
      item.preco_unit = 0;
      item.preco_unit_input = '0,00';
    }

    item.subtotal = +(item.quantidade * item.preco_unit).toFixed(2);
  }
  
  // Validação de formulário
  const formValid = computed(() => {
    if (!produtosCarregados.value || !contasCarregadas.value || erroProdutos.value || erroContas.value) return false;
    if (!venda.cliente_id || !venda.data_venda) return false;
    if (!venda.itens.length || !parcelasCount.value) return false;
    if (!venda.itens.every(i => i.produto_id && i.quantidade > 0)) return false;

    if (parcelasArray.value.some(p => p.conta_financeira_id != null &&
      !contasFinanceiras.value.some(c => c.id === Number(p.conta_financeira_id)))) return false;
    if (venda.pendente) return true;

    for (const p of parcelasArray.value) {
      if (!p.forma_pagamento_id || !p.data_vencimento) return false;

      const fp = p.forma_pagamento_id;
      const isBrinde = (idBrinde.value != null && fp === idBrinde.value);

      if (isBrinde) {
        const temData = !!(p.data_pagamento && String(p.data_pagamento).trim());
        const temConta = (p.conta_financeira_id != null);
        if (temData !== temConta) return false;
        continue;
      }

      const inf = isAInformar(fp);

      if (isFormaComAutorizacao(fp) && !(p.numero_autorizacao || '').trim()) {
        return false;
      }

      if (!inf && !p.data_pagamento) return false;

      if (!inf && (p.data_pagamento || '').trim() && (p.conta_financeira_id == null)) {
        return false;
      }

      if (fp === idCheque.value) {
        if (!p.banco_numero || !p.agencia || !p.cheque_numero) return false;
      }
    }

    return true;
  });
  
  // Salvar
  async function salvarVenda() {
    if (isSubmitting.value || !formValid.value) return;
    isSubmitting.value = true;

    try {
      // ─── marca venda.pendente = true se existir parcela sem data_pagamento
      // (Brinde sem data_pagamento conta como "pendente"?)
      // Se você quiser que Brinde sem pagamento NÃO torne a venda pendente, ajuste aqui.
      const algumaSemPagamento = parcelasArray.value.some(p => !p.data_pagamento);
      venda.pendente = algumaSemPagamento;

      const payload = {
        cliente_pessoa_fisica: venda.cliente_pessoa_fisica,
        cliente_id:            venda.cliente_id,
        data_venda:            venda.data_venda,
        data_pagamento:        venda.data_pagamento || null,
        valor_total:           totalVendaEfetivo.value,
        status:                false,
        por:                   userName,
        parcelas:              parcelasCount.value,
        itens:                 venda.itens.map(i => ({
          produto_id: i.produto_id,
          quantidade: i.quantidade,
          preco_unit: i.preco_unit,
          subtotal:   i.subtotal
        })),
        pendente: venda.pendente,
        pagamentos: parcelasArray.value.map(p => {
          const isBrindeLocal = (idBrinde.value != null && p.forma_pagamento_id === idBrinde.value);
          const isChequeLocal = (idCheque.value != null && p.forma_pagamento_id === idCheque.value);

          return {
            id: p.id,
            forma_pagamento_id: p.forma_pagamento_id,
            data_vencimento: p.data_vencimento,
            valor: isBrindeLocal ? 0 : p.valor,
            data_pagamento: p.data_pagamento || null,
            data_recebimento: p.data_recebimento || null,
            banco_numero: isChequeLocal ? (p.banco_numero || null) : null,
            agencia: isChequeLocal ? (p.agencia || null) : null,
            cheque_numero: isChequeLocal ? (p.cheque_numero || null) : null,
            conta_financeira_id: p.conta_financeira_id || null,
            numero_autorizacao: isBrindeLocal
              ? null
              : ((p.numero_autorizacao || '').trim() || null),
          };
        })
      };

      if (venda.id) {
        Object.assign(payload, paymentCollectionOperations(originalPayments, payload.pagamentos, 'data_vencimento', { operationalAccountSelection: true }));
        await axios.put(`/loja/vendas/${venda.id}`, payload);
      } else {
        const res = await axios.post('/loja/vendas', payload);
        venda.id = res.data.id;
      }

      router.push('/loja/vendas');
    } catch (err) {
      console.error('Erro ao salvar venda:', err);
      alert(err.response?.data?.error || 'Erro ao salvar venda. Verifique os dados e tente novamente.');
    } finally {
      isSubmitting.value = false;
    }
  }
  
watch(
  () => parcelasArray.value.map(p => p.data_vencimento),
  (newVencs, oldVencs) => {
    parcelasArray.value.forEach((p, idx) => {
      // só atualiza data_pagamento se ela ainda era igual ao vencimento antigo
      if (p.data_pagamento === oldVencs[idx]) {
        p.data_pagamento = newVencs[idx];
      }
    });
  },
  { deep: true }
);


  function cancelar() {
    router.push('/loja/vendas');
  }
  </script>
    
  <style scoped>
  .spacer {
    margin-bottom: 1rem;
  }
  .section-title {
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .required {
    color: red;
  }
  .disabled-input {
    background: #e9ecef;
  }
  .form-actions {
    margin-top: 1.5rem;
  }
  .section-title {
  font-size: 1.0rem;  /* igual ao tamanho do h4.form-title */
  font-weight: bold;
  margin-bottom: 0.5rem;
}

  </style>
  